<script setup>
import { listProduct } from "~/constants/product";

const seoTitle = "Sản phẩm";
const seoDescription = "Trang sản phẩm";

useHead({
  title: seoTitle,
  meta: [
    { name: "description", content: seoDescription },
    { name: "og:title", content: seoTitle },
    { name: "og:description", content: seoDescription },
    { name: "keywords", content: "Trang sản phẩm" },
  ],
});
</script>
<template>
  <h1 class="text-center font-semibold text-[36px] mt-[80px] mb-[50px]">Sản phẩm</h1>
  <div class="flex flex-wrap justify-between px-[109px] max-md:px-[0] m-auto max-md:gap-[10px]">
    <nuxt-link
      v-for="item in listProduct"
      :key="item.id"
      :to="item.url"
      class="w-[calc((100%-100px)/5)] max-xl:w-[calc((100%-20px)/3)] max-md:w-[calc((100%-20px)/2)] my-[12.5px] max-md:my-[5px] py-[20px] bg-white rounded-[16px] border text-center hover:border-[#ED7F22] cursor-pointer"
    >
      <p class="font-semibold">{{ item.title }}</p>
      <div class="w-[85px] h-[85px] m-auto flex justify-center items-center">
        <nuxt-picture
          loading="lazy"
          :src="item.image"
          :imgAttrs="{ alt: 'qrproduct' + item.id }"
          class="object-cover"
          width="100%"
          height="100%"
        />
      </div>
    </nuxt-link>
  </div>
</template>
